import Loader from './loader';

export default class PasswordReset {
    constructor($form) {
        this.$form = $form;
        this.$error = $form.querySelector('[data-error]');
        this.$ok = $form.querySelector('[data-ok]');
        this.$password = $form.querySelector('#reset-new-password');
        this.$passwordConfirm = $form.querySelector('#reset-new-password-confirm');
        this.loader = (new Loader($form.querySelector('[data-loader]')));

        let url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        this.urlParts = {};

        for(var i = 0; i < url.length; i++)
        {
            try {
                var tmp = url[i].split('=');
                this.urlParts[tmp[0]] = decodeURIComponent(tmp[1]);
            } catch (e) {
            }
        }
        if (this.urlParts.email && this.urlParts['reset-token']) {
            // trigger event to open the correct model
            var event = new CustomEvent("open-model", {'detail': {
                    id: 'password-reset-modal',
                }});

            document.dispatchEvent(event);
        }

        this.submit = this.submit.bind(this);
        this.fetch = this.fetch.bind(this);

        this.$form.addEventListener('submit', this.submit);
    }

    async submit(e) {
        e.preventDefault();
        this.$ok.classList.remove('d-none');
        this.$error.classList.add('d-none');

        if (! this.$password.value) {
            let div = document.createElement("div");
            div.innerHTML = '<div class="form__error form__error--general">De 2 wachtwoorden komen niet overeen.</div>';
            this.$form.prepend(div)
            return false;
        }

        if (this.$passwordConfirm.value !== this.$password.value) {
            let div = document.createElement("div");
            div.innerHTML = '<div class="form__error form__error--general">De 2 wachtwoorden komen niet overeen.</div>';
            this.$form.prepend(div)
            return false;
        }

        this.loader.loading(true);

        const result = await this.fetch();

        if (result) {
            location.href = placeholders.baseUri ? placeholders.baseUri : '';
            return false;
        }
        this.loader.loading(false);
        this.$error.classList.remove('d-none');
        this.$ok.classList.add('d-none');
    }

    async fetch() {
        const body = JSON.stringify({
            email: this.urlParts.email,
            'reset-token': this.urlParts['reset-token'],
            password: this.$password.value
        });

        try {
            const request = await fetch(
                    placeholders.baseUri
                    ? placeholders.baseUri + '/ajax/type/63/reset'
                    : 'ajax/type/63/reset',
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: body
                    }
            );
            const result = await request.json();
            return result;
        } catch (e) {
            console.log(e);
            // this.loader.loading(false);
        }
    }
}